<div class="week-row week-header">
  <span></span>
  <div class="week-track">
    @for (tick of ticks(); track tick.minutes) {
      <span class="week-tick" [style.left.%]="tick.offsetPercent">{{ tick.label }}</span>
    }
  </div>
  <span></span>
  <span class="week-amplitude" translate>WORK_SCHEDULE_LBL_AMPLITUDE</span>
</div>

@for (row of rows(); track row.dayOfWeek) {
  <div class="week-row" [class.week-row-off]="row.day == null">
    <span class="week-day">{{ row.labelKey | translate }}</span>
    <div class="week-track">
      @for (tick of ticks(); track tick.minutes) {
        <span class="week-gridline" [style.left.%]="tick.offsetPercent"></span>
      }
      @if (row.amplitudeMinutes > 0) {
        <span
          class="week-bar"
          [style.left.%]="row.offsetPercent"
          [style.width.%]="row.widthPercent"
        ></span>
      }
    </div>
    @if (row.day == null) {
      <span class="week-hours" translate>WORK_SCHEDULE_LBL_NOT_WORKED</span>
      <span class="week-amplitude">-</span>
    } @else {
      <span class="week-hours">{{ row.startLabel }} – {{ row.endLabel }}</span>
      <span class="week-amplitude">{{ row.amplitudeLabel }}</span>
    }
  </div>
}

<div class="week-total">
  @if(workedDayCount() == 1) {
   {{ 'WORK_SCHEDULE_LBL_WEEK_TOTAL_ONE' | translate: { days: workedDayCount(), amplitude: weekAmplitudeLabel()} }}
  }
  @else {
  {{ 'WORK_SCHEDULE_LBL_WEEK_TOTAL' | translate: {days: workedDayCount(), amplitude: weekAmplitudeLabel()} }}
  }
  </div>
